import "babel-polyfill";
import "react-hot-loader/patch";
import logger from "./util/logger";

// tslint:disable no-any
declare var module: any;
declare var window: any;
declare var process: any;
// tslint:enable no-any

import moment from "moment";
import "moment/locale/fi";
moment.locale("fi");

import React from "react";
import ReactDOM from "react-dom";

import { AppContainer } from "react-hot-loader";

import Root from "./Root";

import "./index.scss";

import createRootStore from "./ducks/RootStore";

import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import createMuiTheme from "material-ui/styles/createMuiTheme";
import createPalette from "material-ui/styles/createPalette";
import { blue, red } from "material-ui/colors";

// Customize theme here
const muiTheme = createMuiTheme({
    palette: createPalette({
        primary: {
            ...blue,

            main: "#2196F3",
            500: "#92c9f0",
            900: "#3a649e",
        },

        secondary: blue,
        error: {
            ...red,
        },
        type: "light",
    }),
    overrides: {
        MuiAppBar: {
            root: {
                height: 48,
                background: "#fff",
            },
        },
        MuiBottomNavigation: {
            root: {
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
            },
        },
        MuiBottomNavigationAction: {
            root: {
                color: blue[500],
            },
            selected: {
                color: "#92c9f0",
            },
        },
        MuiButton: {
            flatPrimary: {
                border: "2px solid #92c9f0",
                borderRadius: 10,
                textTransform: "none",
                fontSize: "1.3em",
                backgroundColor: "white",
                color: "#646363",
                padding: "0px 8px",
                "&:disabled": {
                    border: "2px solid rgba(0, 0, 0, 0.15)",
                    color: "#646363",
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                },
            },
        },
        MuiTypography: {
            colorTextSecondary: {
                color: "#646363",
            },
            colorInherit: {
                color: "#646363",
            },
        },
        MuiSelect: {
            icon: {
                color: "#646363",
            },
        },
    },
});

export const store = createRootStore();

// tslint:disable no-any
const render = (Component: any) => {
    ReactDOM.render(
        <MuiThemeProvider theme={muiTheme}>
            <AppContainer>
                <Component store={store} />
            </AppContainer>
        </MuiThemeProvider>,
        document.getElementById("app-root")
    );
};

if (!window.cordova) {
    logger.info("Running on browser or simulator");
    render(Root);
} else {
    logger.info("Running on device");
    document.addEventListener(
        "deviceready",
        function () {
            logger.info("Device Ready");
            render(Root);
        },
        true
    );
}
if (module && module.hot) {
    logger.log("Hot reloading...");
    module.hot.accept("./Root", () => {
        render(Root);
    });
}



// WEBPACK FOOTER //
// ./src/index.tsx